import {
  IMAGE_FILE_DATA_LOADING,
  IMAGE_FILE_DATA_LOADED,
  IMAGE_FILE_DATA_LOAD_FAILED,
  IMAGE_FILE_SAVING,
  IMAGE_FILE_SAVED,
  IMAGE_FILE_SAVE_FAILED,
  IMAGE_FILE_CROPS_LOADING,
  IMAGE_FILE_CROPS_LOADED,
  IMAGE_FILE_CROPS_LOAD_FAILED,
  IMAGE_FILE_RESET,
  IMAGE_FILE_TOGGLE_EDITABLE,
  IMAGE_FILE_ADD_KEYWORD,
  IMAGE_FILE_REMOVE_KEYWORD,
  IMAGE_FILE_UPDATE_FIELD
} from 'constants/actiontypes';

const INITIAL_STATE = {
  image: {},
  editable: false,
  loading: false,
  loaded: false,
  crops: [],
  cropLoading: false,
  cropLoaded: false,
  updating: false,
  updated: false,
  updateData: {}
};

export function keywords(state = [], action) {
  switch(action.type) {
    case IMAGE_FILE_ADD_KEYWORD:
      const filteredKeys = [];
      action.keywords.forEach(key => {
        const tmpKey = key.trim().toLowerCase();
        if (tmpKey.length > 2 && state.indexOf(tmpKey) < 0) {
          filteredKeys.push(tmpKey);
        }
      });
      const ret = [...state, ...filteredKeys];
      return ret;
    case IMAGE_FILE_REMOVE_KEYWORD:
      return state.filter((keyword) => (keyword !== action.keyword.trim().toLowerCase()))
    default:
      return state;
  };
}


export default (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case IMAGE_FILE_DATA_LOADING:
      return Object.assign({}, state, {
        loading: true
      });
    case IMAGE_FILE_DATA_LOADED:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        image: action.data,
      });
    case IMAGE_FILE_RESET:
    case IMAGE_FILE_DATA_LOAD_FAILED:
      return INITIAL_STATE;
    case IMAGE_FILE_SAVING:
      return Object.assign({}, state, {
        updating: true
      });
    case IMAGE_FILE_SAVED:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        loading: false,
        loaded: true,
        editable: false,
        updateData: {},
        image: Object.assign({}, state.image, action.data),
      });
    case IMAGE_FILE_SAVE_FAILED:
      return Object.assign({}, state, {
        updating: false,
        updated: false,
      });
    case IMAGE_FILE_CROPS_LOADING:
      return Object.assign({}, state, {
        cropLoading: true
      });
    case IMAGE_FILE_CROPS_LOADED:
      return Object.assign({}, state, {
        cropLoading: false,
        cropLoaded: true,
        crops: action.data
      });
    case IMAGE_FILE_CROPS_LOAD_FAILED:
      return Object.assign({}, state, {
        cropLoading: false,
        cropLoaded: false,
        crops: []
      });
    case IMAGE_FILE_TOGGLE_EDITABLE:
      return Object.assign({}, state, {
        editable: action.data,
        updateData: (action.data === true) ? Object.assign({}, state.image) : {},
      });
    case IMAGE_FILE_ADD_KEYWORD:
    case IMAGE_FILE_REMOVE_KEYWORD:
      return Object.assign({}, state, {
        updateData: Object.assign({}, state.updateData, {
          keywords: keywords(state.updateData.keywords, action)
        })
      });
    case IMAGE_FILE_UPDATE_FIELD:
      return Object.assign({}, state, {
        updateData: Object.assign({}, state.updateData, {
          [action.name]: action.value
        })
      });
    default: return INITIAL_STATE;
  }
};



/** WEBPACK FOOTER **
 ** ./reducers/image.js
 **/